import { RightOutlined } from "@ant-design/icons";
import {
  Add,
  DeleteOutline,
  DeleteOutlineOutlined,
  Edit,
  InfoOutlined,
  Person,
} from "@mui/icons-material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import {
  Autocomplete,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Button,
  FormControl,
  IconButton,
  MenuItem,
  Paper,
  Select,
  TextField
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { CircleIcon, Square } from "lucide-react";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { toast, ToastContainer } from "react-toastify";
import defaultImage from "../../assets/svg/defultImage.svg";
import DeleteModal from "../../components/Modals/DeleteModal";
import { newHost } from "../Categories/CategoryProfile";
import { newImageUrl } from "../Manufacturers/ManufactureProfile";

const PropertiesValues = ({ properityValues = [], propertyId, token }) => {
  const [allValues, setAllValues] = useState(properityValues);
  const [valueId, setValueId] = useState(null);
  const [removeValueShow, setRemoveValueShow] = useState(false);
  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      value: [{ value: "" }],
    },
  });

  const { fields, append } = useFieldArray({
    name: "value",
    control,
  });

  useEffect(() => {
    if (fields.length === 0) {
      append({ value: "" });
    }
  }, [fields, append]);

  const createPropertyValue = async (data) => {
    const newValue = data.value.at(-1)?.value || "";

    try {
      const response = await axios.post(
        `${newHost}portal/users/vehicles/property-values`,
        {
          value: newValue,
          property_id: propertyId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(response.data.data.message);
      const newEntry = response.data.data.vehicle_property_value;

      if (newEntry?.id) {
        setAllValues((prev) => [...prev, newEntry]);
        reset({ value: [{ value: "" }] });
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
  const handleRemoveValueShow = (value) => {
    setValueId(value.id);
    setRemoveValueShow(true);
  };
  const handleRemoveValueClose = () => {
    setRemoveValueShow(false);
  };
  const deletePropertyValue = async () => {
    try {
      const response = await axios.delete(
        `${newHost}portal/users/vehicles/property-values/${valueId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(response.data.data.message);
      setRemoveValueShow(false);
      const updated = allValues.filter((v) => v.id !== valueId);
      setAllValues(updated);
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  return (
    <>
      <DeleteModal
        showDelete={removeValueShow}
        handleDeleteClose={handleRemoveValueClose}
        textMessage={
          " Are you sure you want to remove this value from Property?"
        }
        deleteFunction={deletePropertyValue}
      />
      <div className="p-3 mb-3 rounded-2">
        {allValues.map((value, idx) => (
          <div key={value.id || idx} className="d-flex mt-2 align-items-center">
            <TextField
              className="w-100 me-2"
              value={value.value}
              size="small"
            />
            <IconButton onClick={() => handleRemoveValueShow(value)}>
              <DeleteOutlineOutlined color="error" />
            </IconButton>
          </div>
        ))}

        <form onSubmit={handleSubmit(createPropertyValue)}>
          {fields.map((field, index) => (
            <div key={field.id} className="d-flex mt-3 align-items-center">
              <TextField
                className="w-100 me-2"
                placeholder="Add value"
                size="small"
                {...register(`value.${index}.value`)}
              />
              <Button
                sx={{ backgroundColor: "black", mb: 1 }}
                type="submit"
                variant="contained"
              >
                Save
              </Button>
            </div>
          ))}
        </form>
      </div>
    </>
  );
};

const BrandVehicle = () => {
  const { user } = useSelector((state) => state.auth);
  const token = user?.token;
  const { categoryId } = useParams();
  const {
    register: registerProperty,
    handleSubmit: submitProperty,
    setValue: setPropertyValue,
    control: controlProperty,
    reset: resetProperty,
    formState: { errors: errorProperty },
  } = useForm({
    defaultValues: {
      name: "",
      unit: "",
      is_required: 0,
      type_id: "",
      display_order: "",
      category_ids: [],
      data_type: "",
      slug: "",
    },
  });
  const { register, handleSubmit, setValue, control, reset } = useForm({
    defaultValues: {
      name: "",
      description: "",
      logo: "",
      status: "",
      category_ids: [],
    },
  });

  const [vehiclesBrands, setVehiclesBrands] = useState([]);
  const [vehiclesProperties, setVehiclesProperties] = useState([]);
  const [vehiclesTypes, setVehiclesTypes] = useState([]);
  const [brandShow, setBrandShow] = useState(false);
  const [propertyShow, setPropertyShow] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [isPropertyEdit, setIsPropertyEdit] = useState(false);
  const [deleteShow, setDeleteShow] = useState(false);
  const [deletePropertyShow, setDeletePropertyShow] = useState(false);
  const [propertyProfileShow, setPropertyProfileShow] = useState(false);
  const [brandId, setBrandId] = useState(null);
  const [propertyId, setPropertyId] = useState(null);
  const [propertyData, setPropertyData] = useState({});

  const [tabsvalue, setTabsValue] = useState(0);

  const FileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        setImagePreview(reader.result);
        setValue("logo", file);
      };

      reader.readAsDataURL(file);
    }
  };

  const handleBrandShow = () => {
    setBrandShow(true);
    setIsEdit(false);
  };

  const handleBrandClose = () => {
    setBrandShow(false);
    setImagePreview(null);
    reset();
  };

  const handleUpdateShow = (e, brand) => {
    e.stopPropagation();
    setIsEdit(true);
    setBrandId(brand.id);
    setBrandShow(true);
    // setUploadImage(newImageUrl + brand.logo_path)
    console.log(brand);
    setValue("name", brand.name);
    setValue("description", brand.description);
    setValue("status", brand.status);
    console.log(brand.logo_path);

    if (brand.logo_path) {
      setImagePreview(newImageUrl + brand.logo_path);
    }
    // setValue("logo" , newImageUrl + brand.logo_path)
  };

  const handleDeleteShow = (e, id) => {
    e.stopPropagation();
    setBrandId(id);
    setDeleteShow(true);
  };

  const handleDeleteClose = () => {
    setDeleteShow(false);
  };

  const handlePropertyShow = () => {
    setPropertyShow(true);
    setIsPropertyEdit(false);
  };

  const handlePropertyClose = () => {
    setPropertyShow(false);
    setIsPropertyEdit(false);
    resetProperty({
      name: "",
      unit: "",
      is_required: 0,
      type_id: "",
      display_order: "",
      data_type: "",
    });
  };

  const handleUpdatePropertyShow = (e, properity) => {
    console.log("ppppp", properity);

    e.stopPropagation();
    setIsPropertyEdit(true);
    setPropertyId(properity.id);
    setPropertyShow(true);
    console.log(properity);
    setPropertyValue("name", properity.name);
    setPropertyValue("is_required", properity.is_required);
    setPropertyValue("data_type", properity.data_type);

    setPropertyValue("display_order", properity.display_order);
    setPropertyValue("slug", properity.slug);
    if (properity.unit) {
      setPropertyValue("unit", properity.unit);
    }
    if (properity.type_id) {
      setPropertyValue("type_id", properity.type_id);
    }
  };

  const handleDeletePropertyShow = (e, id) => {
    e.stopPropagation();
    setPropertyId(id);
    setDeletePropertyShow(true);
  };

  const handleDeletePropertyClose = () => {
    setDeletePropertyShow(false);
  };

  const handlePropertyProfileShow = (e, properity) => {
    e.stopPropagation();
    console.log(properity);

    setPropertyProfileShow(true);
    setPropertyData(properity);
  };

  const handlePropertyProfileClose = () => {
    setPropertyProfileShow(false);
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <div className="d-flex gap-2 align-items-center justify-content-center">
            <img
              style={{ width: "25px", height: "25px" }}
              src={
                params.row.logo_path
                  ? "https://estbn.com/EstbnNew/public" + params.row.logo_path
                  : defaultImage
              }
              alt=""
            />
            <p className="m-0">{params.row.name}</p>
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.9,
      minWidth: 120,
      // renderCell: (params) => {
      //     return (
      //         <p className="m-0">{params.row.name}</p>
      //     )
      // }
    },
    {
      field: "created_at",
      headerName: "Created on",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <p className="m-0">
            {new Date(params.row.created_at).toLocaleDateString()}
          </p>
        );
      },
    },
    {
      field: "created_by",
      headerName: "Created by",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => {
        return <p className="m-0">{params.row.creator?.name}</p>;
      },
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 0.6,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <div className="d-flex justify-content-evenly align-items-center h-100 w-100">
            <IconButton
              onClick={(e) => handleUpdateShow(e, params.row)}
              color="default"
              aria-label="edit"
              size="small"
              style={{ width: "33%" }}
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={(e) => handleDeleteShow(e, params.row?.id)}
              color="error"
              aria-label="delete"
              size="small"
              style={{ width: "33%" }}
            >
              <DeleteOutlineOutlined />
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                navigate(
                  `/vehiclesCategories/${categoryId}/vehiclesBrand/${params.row.id}`
                );
              }}
              color="default"
              aria-label="view-details"
              style={{ width: "30%" }}
              size="small"
            >
              <RightOutlined />
            </IconButton>
          </div>
        );
      },
    },
  ];
  const PropertiesColumns = [
    {
      field: "name",
      headerName: "Name",
      flex: 0.9,
      minWidth: 120,
    },
    {
      field: "data_type",
      headerName: "Data Type",
      flex: 0.9,
      minWidth: 120,
    },
    {
      field: "unit",
      headerName: "Unit",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <p className="m-0">{params.row.unit ? params.row.unit : "None"}</p>
        );
      },
    },

    {
      field: "Actions",
      headerName: "Actions",
      flex: 0.6,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <div className="d-flex justify-content-evenly align-items-center h-100 w-100">
            <IconButton
              onClick={(e) => handleUpdatePropertyShow(e, params.row)}
              color="default"
              aria-label="edit"
              size="small"
              style={{ width: "33%" }}
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={(e) => handleDeletePropertyShow(e, params.row?.id)}
              color="error"
              aria-label="delete"
              size="small"
              style={{ width: "33%" }}
              disabled
            >
              <DeleteOutlineOutlined />
            </IconButton>
            <IconButton
              onClick={(e) => handlePropertyProfileShow(e, params.row)}
              color="default"
              aria-label="view-details"
              style={{ width: "30%" }}
              size="small"
            >
              <RightOutlined />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const getAllVehiclesBrands = async () => {
    try {
      const response = await axios.get(
        `${newHost}portal/users/vehicles/categories/${categoryId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response);
      setVehiclesBrands(response.data.data.vehicle_category?.brands);
      setVehiclesProperties(response.data.data.vehicle_category?.properties);
      setCategoryVehicleType(response.data.data.vehicle_category?.types);
      setCategoryById(response.data.data.vehicle_category);
    } catch (error) {
      console.log(error);
    }
  };
  const submitBrands = async (data) => {
    console.log(data);
    const formData = new FormData();

    formData.append("logo", data.logo);

    formData.append("name", data.name);
    formData.append("description", data.description);
    formData.append("status", data.status);
    formData.append("category_ids[]", categoryId);

    if (isEdit) {
      formData.append("_method", "PATCH");
      try {
        const response = await axios.post(
          `${newHost}portal/users/vehicles/brands/${brandId}`,
          formData,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log(response);
        toast.success(response.data.message);
        getAllVehiclesBrands();
        setBrandShow(false);
        setImagePreview(null);
        setIsEdit(false);
        reset();
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message);
      }
    } else {
      try {
        const response = await axios.post(
          `${newHost}portal/users/vehicles/brands`,
          formData,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log(response);
        toast.success(response.data.message);
        getAllVehiclesBrands();
        setBrandShow(false);
        reset();
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message);
      }
    }
  };
  const deleteVehicleBrand = async () => {
    try {
      const response = await axios.delete(
        `${newHost}portal/users/vehicles/brands/${brandId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response);
      setDeleteShow(false);
      toast.success(response.data.data.message);
      getAllVehiclesBrands();
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  };
  const getAllVehiclesTypes = async () => {
    try {
      const response = await axios.get(
        `${newHost}portal/users/vehicles/types`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response);
      setVehiclesTypes(response.data.data.vehicle_types);
    } catch (error) {
      console.log(error);
    }
  };
  const handleVehiclePropertySubmit = async (data) => {
    console.log(data);
    if (isPropertyEdit) {
      try {
        const response = await axios.post(
          `${newHost}portal/users/vehicles/properties/${propertyId}`,
          {
            ...data,
            _method: "PATCH",
            category_ids: [categoryId],
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log(response);
        toast.success(response.data.message);
        getAllVehiclesBrands();
        setPropertyShow(false);
        setIsPropertyEdit(false);

        resetProperty({
          name: "",
          unit: "",
          is_required: 0,
          type_id: "",
          display_order: "",
          data_type: "",
        });
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message);
      }
    } else {
      try {
        const response = await axios.post(
          `${newHost}portal/users/vehicles/properties`,
          {
            ...data,
            category_ids: [categoryId],
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log(response);
        toast.success(response.data.message);
        getAllVehiclesBrands();
        setPropertyShow(false);
        resetProperty({
          name: "",
          unit: "",
          is_required: 0,
          type_id: "",
          display_order: "",
          data_type: "",
        });
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message);
      }
    }
  };
  const deleteVehicleProperty = async () => {
    try {
      const response = await axios.delete(
        `${newHost}portal/users/vehicles/properties/${propertyId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response);
      setDeletePropertyShow(false);
      toast.success(response.data.message);
      getAllVehiclesBrands();
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    getAllVehiclesBrands();
    getAllVehiclesTypes();
  }, []);

  // Mariam
  const BASE_IMAGE_URL = "https://estbn.com/EstbnNew/public";

  const navigate = useNavigate();

  const customStyles = {
    flexCenterXY: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    supplierImgHolder: {
      width: "150px",
      height: "150px",
      borderRadius: "50%",
      overflow: "hidden",
      margin: "0 auto",
      marginBottom: "15px",
      border: "1px solid #eee",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#f0f0f0",
    },
    categoryImgCard: {
      width: "35px",
      height: "35px",
      borderRadius: "8px",
      backgroundColor: "#f8f9fa",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#e2e6ea",
      },
    },
    stuffProfileInfo: {
      padding: "15px 0",
      borderTop: "1px solid #dee2e6",
      marginTop: "15px",
    },
    agentInfoSupp: {
      fontSize: "1rem",
      fontWeight: "600",
      color: "#343a40",
      marginBottom: "10px",
    },
    categoryInfoText: {
      fontSize: "0.9rem",
      color: "#6c757d",
      lineHeight: "1.6",
    },
    scrollableTableWrapper: {
      overflowX: "auto",
      maxWidth: "100%",
    },
    minVH100: { minHeight: "100vh" },
    margin4: { margin: "1.5rem" },
    padding3: { padding: "1rem" },
    rounded3: { borderRadius: "0.5rem" },
    border2: {
      borderWidth: "2px",
      borderColor: "#e0e0e0",
      borderStyle: "solid",
    },
    bgLightRounded4: { backgroundColor: "#f8f9fa", borderRadius: "1rem" },
    fwSemibold: { fontWeight: 600 },
    fwBold: { fontWeight: 700 },
    textCenter: { textAlign: "center" },
    modalHeader: {
      borderBottom: "none",
      paddingBottom: "0",
    },
    modalTitle: {
      fontSize: "1.5rem",
      fontWeight: "bold",
      color: "#333",
    },
    companyLogoUpload: {
      border: "2px dashed #D8D8D8",
      borderRadius: "15px",
      padding: "20px",
      marginTop: "10px",
      marginBottom: "20px",
    },
    supplierProfileLabelColor: {
      color: "#535353",
    },
    supplierLabelSize: {
      fontSize: "1rem",
    },
    inputGroupResponsive: {
      flexDirection: "column",
      "@media (min-width: 768px)": {
        flexDirection: "row",
      },
    },
    btnLight: {
      backgroundColor: "#f8f9fa",
      borderColor: "#f8f9fa",
      color: "#212529",
    },
    btnDark: {
      backgroundColor: "#212529",
      borderColor: "#212529",
      color: "#fff",
    },
    textareaStyle: {
      padding: 10,
      borderRadius: 15,
      border: "solid 2px #D8D8D8",
      resize: "vertical",
    },
    uploadFileResponsive: "upload-file-responsive",
  };

  const [categoryVehicleType, setCategoryVehicleType] = useState([]);
  const [categoryById, setCategoryById] = useState({});
  const [loadingCategory, setLoadingCategory] = useState(true);
  const [errorCategory, setErrorCategory] = useState(null);

  const [typeModalShow, setTypeModalShow] = useState(false);
  const [isEditType, setIsEditType] = useState(false);
  const [currentTypeId, setCurrentTypeId] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleteEndpoint, setDeleteEndpoint] = useState("");
  const [deleteSuccessMessage, setDeleteSuccessMessage] = useState("");
  const [deleteAfterRedirect, setDeleteAfterRedirect] = useState(false);

  const {
    register: registerType,
    handleSubmit: submitType,
    setValue: setFormValue,
    control: controlType,
    reset: resetType,
    formState: { errors, isSubmitting },
  } = useForm();

  const handleFileChange = (e, fieldName, setPreviewState) => {
    const file = e.target.files[0];
    if (file) {
      setPreviewState(URL.createObjectURL(file));
      setFormValue(fieldName, file);
    } else {
      setPreviewState(null);
      setFormValue(fieldName, null);
    }
  };

  const handleTypeModalShow = () => {
    setIsEditType(false);
    setImagePreview(null);
    resetType({ name: "", description: "", status: "", slug: "" });
    setTypeModalShow(true);
  };

  const handleTypeModalClose = () => {
    setTypeModalShow(false);
    setImagePreview(null);
    resetType();
    setCurrentTypeId(null);
  };

  const submitTypeForm = async (data) => {
    console.log("Form Data Submitted for Type:", data);

    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("slug", data.slug);
    if (
      data.description !== null &&
      data.description !== undefined &&
      data.description !== ""
    ) {
      formData.append("description", data.description);
    } else if (isEditType) {
      formData.append("description", "");
    }
    formData.append("status", data.status);

    let url = "";
    let method = "";

    if (isEditType && currentTypeId) {
      formData.append("_method", "PATCH");
      if (data.image) {
        formData.append("image", data.image);
      }
      url = `${newHost}portal/users/vehicles/types/${currentTypeId}`;
      method = "post";
    } else {
      if (!categoryId) {
        toast.error("Cannot add type: Category ID is missing.");
        return;
      }
      formData.append("category_id", categoryId);
      if (data.image) {
        formData.append("image", data.image);
      }
      url = `${newHost}portal/users/vehicles/types`;
      method = "post";
    }

    try {
      const response = await axios({
        method: method,
        url: url,
        data: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("API Response for Type:", response.data);
      toast.success(
        isEditType ? "Type updated successfully!" : "Type added successfully!"
      );
      handleTypeModalClose();
      getAllVehiclesBrands();
    } catch (error) {
      console.error(
        "API Error for Type:",
        error.response ? error.response.data : error.message
      );
      let errorMessage = "Operation failed: ";
      if (error.response?.status === 401) {
        errorMessage +=
          "Authentication failed. Your token might be invalid or expired. Please log in again.";
      } else if (error.response?.data?.message) {
        errorMessage += error.response.data.message;
      } else if (error.message) {
        errorMessage += error.message;
      }
      toast.error(errorMessage);
    }
  };

  const handleEditTypeClick = (typeData) => {
    setIsEditType(true);
    setCurrentTypeId(typeData.id);
    resetType(); // Reset form first
    setFormValue("name", typeData.name);
    setFormValue("description", typeData.description || "");
    setFormValue("status", typeData.status.toLowerCase());
    setFormValue("slug", typeData.slug || "");
    setImagePreview(newImageUrl + typeData.images?.image_url || defaultImage);
    setTypeModalShow(true);
  };

  // --- Delete Modal Functions ---
  const handleDeleteClick = (item, type) => {
    if (type === "type") {
      setItemToDelete({ id: item.id, name: item.name, type: type });
      setDeleteEndpoint(`${newHost}portal/users/vehicles/types/${item.id}`);
      setDeleteSuccessMessage(`Type "${item.name}" deleted successfully.`);
      setDeleteAfterRedirect(false);
      setShowDeleteModal(true);
    } else if (type === "category") {
      setItemToDelete({ id: item.id, name: item.name, type: type });
      setDeleteEndpoint(
        `${newHost}portal/users/vehicles/categories/${item.id}`
      );
      setDeleteSuccessMessage(
        `Category "${item.name}" and its associated data deleted successfully.`
      );
      setDeleteAfterRedirect(true);
      setShowDeleteModal(true);
    }
  };

  const handleDeleteItemClose = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
    setDeleteEndpoint("");
    setDeleteSuccessMessage("");
    setDeleteAfterRedirect(false);
  };

  const confirmDeleteItem = async () => {
    if (!itemToDelete || !deleteEndpoint || !token) {
      toast.error(
        "Error: Item to delete or endpoint missing, or token invalid."
      );
      return;
    }

    try {
      const response = await axios.delete(deleteEndpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("Delete API Response:", response.data);
      toast.success(deleteSuccessMessage);
      handleDeleteItemClose();

      if (deleteAfterRedirect) {
        navigate("/vehicles/categories");
      } else {
        getAllVehiclesBrands();
      }
    } catch (error) {
      console.error(
        "Delete API Error:",
        error.response ? error.response.data : error.message
      );
      let errorMessage = "Deletion failed: ";
      if (error.response?.status === 401) {
        errorMessage +=
          "Authentication failed. Your token might be invalid or expired.";
      } else if (error.response?.data?.message) {
        errorMessage += error.response.data.message;
      } else {
        errorMessage += error.message;
      }
      toast.error(errorMessage);
    }
  };

  const handleEditCategoryClick = () => {
    toast.info("Edit Category functionality is not yet implemented.");
  };

  const paginationModel = { page: 0, pageSize: 10 };

  const typesColumns = [
    {
      field: "name",
      headerName: "Name",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => (
        <Box sx={customStyles.flexCenterXY} gap={1}>
          <Box
            component="img"
            sx={{ width: "25px", height: "25px", mx: 1, objectFit: "contain" }}
            src={
              params.row.images?.image_url
                ? `${BASE_IMAGE_URL}${params.row.images.image_url}`
                : defaultImage
            }
            alt={params.row.name}
          />
          <span>{params?.row.name}</span>
        </Box>
      ),
    },
    { field: "status_label", headerName: "Status", flex: 1, minWidth: 120 },
    {
      field: "created_at",
      headerName: "Created on",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => (
        <div>
          {new Date(params.row.created_at).toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
          })}
        </div>
      ),
    },
    {
      field: "creator",
      headerName: "Created by",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => <div>{params.row?.creator?.name || "N/A"}</div>,
    },
    {
      field: "Actions",
      headerName: "Action",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <Box>
          <IconButton
            style={{ width: "25%" }}
            color="default"
            aria-label="edit"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              handleEditTypeClick(params.row);
            }}
          >
            <Edit />
          </IconButton>
          <IconButton
            style={{ width: "25%" }}
            color="error"
            aria-label="delete"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteClick(params.row, "type");
            }}
          >
            <DeleteOutline />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <>
      <DeleteModal
        showDelete={showDeleteModal}
        handleDeleteClose={handleDeleteItemClose}
        textMessage={
          itemToDelete
            ? `Are you sure you want to delete this ${itemToDelete.type} (${itemToDelete.name})?`
            : "Are you sure you want to delete this item?"
        }
        deleteFunction={confirmDeleteItem}
      />
      <DeleteModal
        showDelete={deleteShow}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this Brand?"}
        deleteFunction={deleteVehicleBrand}
      />
      <DeleteModal
        showDelete={deletePropertyShow}
        handleDeleteClose={handleDeletePropertyClose}
        textMessage={" Are you sure you want to delete this Property?"}
        deleteFunction={deleteVehicleProperty}
      />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      {/* Type Add/Edit Modal */}
      <Modal
        show={typeModalShow}
        onHide={handleTypeModalClose}
        dialogClassName=""
      >
        <Modal.Header closeButton style={customStyles.modalHeader}>
          <Modal.Title className="m-0" style={customStyles.modalTitle}>
            {isEditType ? "Update Type" : "Add New Type"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="my-4">
            <form onSubmit={submitType(submitTypeForm)}>
              <p
                style={{
                  ...customStyles.supplierProfileLabelColor,
                  ...customStyles.fwSemibold,
                  ...customStyles.supplierLabelSize,
                }}
                className="m-0"
              >
                Type Logo
              </p>

              <Box
                sx={{
                  ...customStyles.flexCenterXY,
                  ...customStyles.companyLogoUpload,
                  ...customStyles.inputGroupResponsive,
                  ...customStyles.uploadFileResponsive,
                }}
              >
                <Box
                  sx={{
                    ...customStyles.flexCenterXY,
                    ...customStyles.inputGroupResponsive,
                  }}
                >
                  <img
                    src={imagePreview || defaultImage} // Default image for modal preview
                    alt="Logo Preview"
                    style={{
                      width: "80px",
                      height: "80px",
                      objectFit: "contain",
                      borderRadius: "8px",
                    }}
                  />
                  {!imagePreview && (
                    <p
                      style={{
                        ...customStyles.fwBold,
                        ...customStyles.supplierLabelSize,
                      }}
                      className="my-0 mx-2"
                    >
                      Upload an image. Max size 2MB
                    </p>
                  )}
                </Box>
                <label
                  htmlFor="type-logo"
                  className="btn"
                  style={customStyles.btnLight}
                >
                  Browser
                  <input
                    {...registerType("image")}
                    onChange={(e) =>
                      handleFileChange(e, "image", setImagePreview)
                    }
                    type="file"
                    id="type-logo"
                    className="d-none"
                  />
                </label>
              </Box>

              <div className="my-1">
                <label className="d-block my-1" htmlFor="type-name">
                  Name
                </label>
                <TextField
                  size="small"
                  {...registerType("name", { required: "Name is required" })}
                  id={"type-name"}
                  placeholder="Add Type Name"
                  sx={{ width: "100%" }}
                  error={!!errors.name}
                  helperText={errors.name ? errors.name.message : ""}
                />
              </div>
              <div className="my-1">
                <label className="d-block my-1" htmlFor="type-slug">
                  Slug
                </label>
                <TextField
                  size="small"
                  {...registerType("slug", { required: "Slug is required" })}
                  id={"type-slug"}
                  placeholder="Add Type Slug (e.g., van-type)"
                  sx={{ width: "100%" }}
                  error={!!errors.slug}
                  helperText={errors.slug ? errors.slug.message : ""}
                />
              </div>
              <div className="my-1">
                <label htmlFor="type-description">Description</label>
                <textarea
                  {...registerType("description")}
                  id="type-description"
                  style={customStyles.textareaStyle}
                  rows={3}
                  className="w-100"
                  type="text"
                  placeholder="Enter type description"
                />
              </div>
              <div className="my-1">
                <label htmlFor="type-status">Status</label>
                <Controller
                  name="status"
                  control={controlType}
                  // Removed defaultValue="active"
                  rules={{
                    required: "Status is required",
                    validate: (value) => value !== "" || "Status is required",
                  }} // Ensure empty string is not valid
                  render={({ field }) => (
                    <FormControl sx={{ width: "100%" }} variant="outlined">
                      <Select
                        {...field}
                        label=""
                        labelId="type-status-label"
                        id="type-status"
                        error={!!errors.status}
                        displayEmpty // Allows displaying an empty option
                      >
                        <MenuItem className="custom-menu-item " value="">
                          {" "}
                          {/* Empty option for placeholder */}
                          <em>Select Status</em>
                          <div className="label-size m-0'"></div>
                        </MenuItem>
                        {["active", "inactive"].map((status) => (
                          <MenuItem
                            className="custom-menu-item "
                            key={status}
                            value={status}
                          >
                            <div className="label-size m-0"> {status}</div>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
                {errors.status && (
                  <p style={{ color: "red", fontSize: "0.8rem" }}>
                    {errors.status.message}
                  </p>
                )}
              </div>
              <div className="d-flex gap-4 justify-content-center align-items-center py-4 custom-card-sm">
                <button
                  type="reset"
                  className="px-5 py-2 btn"
                  style={customStyles.btnLight}
                  onClick={handleTypeModalClose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-5 py-2 btn"
                  style={customStyles.btnDark}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Saving..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={propertyProfileShow} onHide={handlePropertyProfileClose}>
        <Modal.Header closeButton>
          <Modal.Title className="m-0">Property Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="my-4 mx-2">
            <div className="d-flex justify-content-between align-items-center">
              <h6 className="m-0">Property Info</h6>
              <div
                className="cursor"
                onClick={(e) => {
                  handleUpdatePropertyShow(e, propertyData);
                  setPropertyProfileShow(false);
                }}
              >
                <Edit />
              </div>
            </div>
            <div className="row ">
              <div className="col-lg-6 col-12">
                <div className="my-3">
                  <div className="d-flex gap-1 align-items-center my-1">
                    <h6 className="main-text-color m-0">Name:</h6>
                    <h6 className="m-0">{propertyData.name}</h6>
                  </div>
                  <div className="d-flex gap-1 align-items-center my-1">
                    <h6 className="main-text-color m-0">Unit:</h6>
                    <h6 className="m-0">
                      {propertyData.unit ? propertyData.unit : "-"}
                    </h6>
                  </div>
                  <div className="d-flex gap-1 align-items-center my-1">
                    <h6 className="main-text-color m-0">Vehicle Type:</h6>
                    <h6 className="m-0">
                      {propertyData.type_name ? propertyData.type_name : "-"}
                    </h6>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-12">
                <div className="my-3">
                  <div className="d-flex gap-1 align-items-center my-1">
                    <h6 className="main-text-color m-0">Data Type:</h6>
                    <h6 className="m-0">{propertyData.data_type}</h6>
                  </div>
                  <div className="d-flex gap-1 align-items-center my-1">
                    <h6 className="main-text-color m-0">Sort Order:</h6>
                    <h6 className="m-0">{propertyData.display_order}</h6>
                  </div>
                  <div className="d-flex gap-1 align-items-center my-1">
                    <div className="d-flex align-items-start gap-2 mx-2">
                      <input
                        type="checkbox"
                        className="my-1"
                        checked={propertyData.is_required == 1}
                      />
                      <p className="m-0 label-size">Is Required</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <PropertiesValues
              token={token}
              properityValues={propertyData.values}
              propertyId={propertyData.id}
            />
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={propertyShow} onHide={handlePropertyClose}>
        <Modal.Header closeButton>
          <Modal.Title className="m-0">
            {isPropertyEdit ? "Update Property " : "Add New Properity"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="my-4">
            <form onSubmit={submitProperty(handleVehiclePropertySubmit)}>
              <div className="my-1 ">
                <label className="d-block my-1" htmlFor="property-name">
                  Property Name
                </label>
                <TextField
                  size="small"
                  {...registerProperty("name")}
                  id={"property-name"}
                  placeholder="Add property Name"
                  sx={{ width: "100%" }}
                />
              </div>
              <div className="my-1">
                <label className="d-block my-1" htmlFor="data_type">
                  Data Type
                </label>
                <Controller
                  name="data_type"
                  control={controlProperty}
                  render={({ field }) => {
                    const options = ["string", "number", "boolean"].map(
                      (option) => ({
                        label: option,
                        id: option,
                      })
                    );

                    return (
                      <>
                        <Autocomplete
                          size="small"
                          options={options}
                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}
                          value={
                            options.find((opt) => opt.id == field.value) || null
                          }
                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              {option.label}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Data Type"
                            />
                          )}
                        />
                      </>
                    );
                  }}
                />
              </div>
              <div className="my-1 ">
                <label className="d-block my-1" htmlFor="unit">
                  Unit
                </label>
                <TextField
                  size="small"
                  {...registerProperty("unit")}
                  id={"unit"}
                  placeholder="Add property unit"
                  sx={{ width: "100%" }}
                />
              </div>
              <div className="my-1 ">
                <label className="d-block my-1" htmlFor="display_order">
                  Sort Order
                </label>
                <TextField
                  size="small"
                  {...registerProperty("display_order")}
                  id={"display_order"}
                  placeholder="Add sort order"
                  sx={{ width: "100%" }}
                  type="number"
                />
              </div>
              <div className="my-2 ">
                <label className="d-block my-2" htmlFor="type_id">
                  Vehicle Type (optional)
                </label>
                <Controller
                  name="type_id"
                  control={controlProperty}
                  defaultValue={0}
                  render={({ field }) => {
                    const options = vehiclesTypes.map((option) => ({
                      label: option.name,
                      id: option.id,
                    }));

                    return (
                      <>
                        <Autocomplete
                          size="small"
                          options={options}
                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}
                          value={
                            options.find((opt) => opt.id == field.value) || null
                          }
                          renderOption={(props, option) => (
                            <li {...props} className="p-2 label-size">
                              {option.label}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Vehicle Type"
                            />
                          )}
                        />
                      </>
                    );
                  }}
                />
              </div>
              <div className="my-2">
                <Controller
                  name="is_required"
                  control={controlProperty}
                  defaultValue={0}
                  render={({ field: { onChange, value, ref } }) => (
                    <div className="d-flex align-items-start gap-2 mx-2">
                      <input
                        type="checkbox"
                        className="my-1"
                        ref={ref}
                        checked={!!value}
                        onChange={(e) => onChange(e.target.checked ? 1 : 0)}
                      />
                      <p className="m-0 label-size">Is Required</p>
                    </div>
                  )}
                />
              </div>
              <input className="d-none" {...register("slug")} type="text" />
              <div className="d-flex gap-4 justify-content-center align-items-center custom-card-sm py-4">
                <button
                  type="reset"
                  className="px-5 py-2 btn btn-light"
                  onClick={handlePropertyClose}
                >
                  Cancel
                </button>
                <button className="px-5 py-2 btn btn-dark">Save</button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={brandShow} onHide={handleBrandClose}>
        <Modal.Header closeButton>
          <Modal.Title className=" m-0">
            {isEdit ? "Update Brand" : "Add New Brand"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="my-4">
            <form onSubmit={handleSubmit(submitBrands)}>
              <p className="spplier-profile-label-color m-0 fw-medium supplier-label-size">
                Brand Logo
              </p>

              <div className=" d-flex justify-content-between align-items-center p-3 company-logo-upload input-group-responsive">
                <div
                  style={{ width: "300px", height: "100px" }}
                  className="d-flex align-items-center upload-file-responsive"
                >
                  <img
                    className="w-25 h-100"
                    src={imagePreview ? imagePreview : defaultImage}
                    alt="Logo Preview"
                  />

                  {imagePreview ? null : (
                    <p className="fw-bold my-0 mx-2 supplier-label-size">
                      Upload an image. Max size 2MB
                    </p>
                  )}
                </div>
                <label htmlFor="company-logo" className="btn btn-light">
                  Browser
                  <input
                    onChange={FileChange}
                    type="file"
                    id="company-logo"
                    className="d-none "
                  />
                </label>
              </div>
              <div className="my-2 ">
                <label className="d-block my-1" htmlFor="brand-name">
                  Name
                </label>
                <TextField
                  size="small"
                  {...register("name")}
                  id={"brand-name"}
                  placeholder="Add Brand Name"
                  sx={{ width: "100%" }}
                />
              </div>
              <div className="my-2">
                <label htmlFor="">Description</label>
                <textarea
                  style={{
                    padding: 10,
                    borderRadius: 15,
                    border: "solid 2px #D8D8D8",
                  }}
                  rows={3}
                  className="w-100"
                  type="text"
                  placeholder="Enter category description"
                  {...register("description")}
                />
              </div>
              <div className="my-3">
                <label htmlFor="">Status</label>
                <Controller
                  name="status"
                  control={control}
                  render={({ field }) => {
                    const options = ["active", "inactive"].map((option) => ({
                      label: option,
                      id: option,
                    }));

                    return (
                      <>
                        <Autocomplete
                          size="small"
                          options={options}
                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}
                          value={
                            options.find((opt) => opt.id == field.value) || null
                          }
                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              {option.label}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Status"
                            />
                          )}
                        />
                      </>
                    );
                  }}
                />
              </div>
              <div className="d-flex gap-4 justify-content-center align-items-center custom-card-sm py-4">
                <button
                  type="reset"
                  className="px-5 py-2 btn btn-light"
                  onClick={handleBrandClose}
                >
                  Cancel
                </button>
                <button className="px-5 py-2 btn btn-dark">Save</button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
      <div className="m-4">
        <div className="row">
          <div className="col-12 col-lg-4 col-xl-3">
            <div className="my-3">
              <h5 className="m-0" style={customStyles.fwSemibold}>
                Category Profile
              </h5>
            </div>
            <div className="">
              <Box
                sx={{
                  ...customStyles.rounded3,
                  ...customStyles.padding3,
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    ...customStyles.bgLightRounded4,
                    ...customStyles.textCenter,
                    ...customStyles.padding3,
                    marginBottom: "1.5rem",
                  }}
                >
                  <Box sx={customStyles.supplierImgHolder}>
                    <Box
                      component="img"
                      // The main category image also uses a direct image_url, no change needed here assuming it's already a full URL
                      src={`${BASE_IMAGE_URL}${categoryById.image_url}`}
                      alt={categoryById.name || "Category Image"}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />
                  </Box>
                </Box>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 style={customStyles.fwBold}>{categoryById.name}</h5>
                  <div className="d-flex gap-2">
                    <Box
                      sx={customStyles.categoryImgCard}
                      onClick={handleEditCategoryClick}
                    >
                      <Edit />
                    </Box>
                    <Box
                      sx={customStyles.categoryImgCard}
                      onClick={() =>
                        handleDeleteClick(categoryById, "category")
                      }
                    >
                      <DeleteOutline />
                    </Box>
                  </div>
                </div>

                <Box sx={customStyles.stuffProfileInfo}>
                  <div style={customStyles.agentInfoSupp}>Category Info</div>
                  <div className="d-flex gap-2 align-items-center my-1">
                    <Person fontSize="small" />
                    <p style={customStyles.fwSemibold} className="m-0">
                      {categoryById.creator?.name || "-"}
                    </p>
                  </div>
                  <div className="d-flex gap-2 align-items-center my-1">
                    <CalendarTodayIcon fontSize="small" />
                    <p style={customStyles.fwSemibold} className="m-0">
                      {`Created on ${new Date(
                        categoryById.created_at
                      ).toLocaleDateString("en-US", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })}`}
                    </p>
                  </div>
                  <div className="d-flex gap-2 align-items-center my-1">
                    <CircleIcon
                      fontSize="small"
                      color={
                        categoryById.status === "active"
                          ? "success"
                          : "disabled"
                      }
                    />
                    <p style={customStyles.fwSemibold} className="m-0">
                      {categoryById.status_label}
                    </p>
                  </div>
                  <div className="d-flex gap-2 align-items-start my-1">
                    <InfoOutlined fontSize="small" />
                    <p style={customStyles.categoryInfoText}>
                      {categoryById.description}
                    </p>
                  </div>
                </Box>

                <Box
                  sx={{ ...customStyles.stuffProfileInfo, marginTop: "1.5rem" }}
                >
                  <div style={customStyles.agentInfoSupp}>Types</div>
                  {categoryById.types && categoryById.types.length > 0 ? (
                    categoryById.types.map((type) => (
                      <div
                        key={type?.id}
                        className="d-flex gap-2 align-items-center my-1"
                      >
                        <Square sx={{ fontSize: "10px" }} />
                        <p style={customStyles.fwSemibold} className="m-0">
                          {type?.name}
                        </p>
                      </div>
                    ))
                  ) : (
                    <p style={customStyles.categoryInfoText}>
                      No types associated with this category.
                    </p>
                  )}
                </Box>
              </Box>
            </div>
          </div>
          <div className="col-lg-9 col-md-8 col-sm-12 p-0">
            <div lassName="p-3">
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <BottomNavigation
                  showLabels
                  value={tabsvalue}
                  onChange={(event, newValue) => setTabsValue(newValue)}
                  sx={{
                    backgroundColor: "transparent",

                    height: "auto",
                    padding: 1,
                    borderRadius: {
                      sm: "10px",
                      xs: 0,
                    },
                    width: "100%",
                    flexDirection: {
                      xs: "column",
                      sm: "row",
                    },

                    alignItems: {
                      xs: "center",
                    },
                    justifyContent: {
                      xs: "center",
                    },

                    ".MuiBottomNavigationAction-root": {
                      fontSize: "20px",
                      minWidth: 0,
                      padding: "8px 12px",
                      justifyContent: "center",
                      width: "100%",
                    },
                    ".Mui-selected": {
                      fontWeight: "bold",
                    },
                  }}
                >
                  <BottomNavigationAction label="Brands" />
                  <BottomNavigationAction label="Types" />
                  <BottomNavigationAction label="Properties" />
                </BottomNavigation>
              </Box>
            </div>
            {tabsvalue == 0 ? (
              <div className="my-3 border rounded-3 min-vh-100">
                <div className="m-4">
                  <div className="d-flex justify-content-between align-items-center my-3  custom-card-sm ">
                    <h4 className="custom-my">Brands</h4>
                    <button
                      onClick={handleBrandShow}
                      className="btn btn-light rounded-3 "
                    >
                      <Add />
                      Add Brand
                    </button>
                  </div>
                  <div className="data-grid-small my-3">
                    <Paper sx={{ height: "auto", width: "100%" }}>
                      <DataGrid
                        autoHeight
                        rows={vehiclesBrands}
                        columns={columns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[5, 10]}
                        sx={{ border: 0 }}
                        checkboxSelection
                      />
                    </Paper>
                  </div>
                </div>
              </div>
            ) : tabsvalue == 1 ? (
              <div className="my-3 border rounded-3 min-vh-100 ">
                <Box sx={{ ...customStyles.padding3 }}>
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        justifyContent: "space-between",
                        alignItems: { xs: "center", md: "center" },
                        gap: { xs: 1, md: 3 },
                      }}
                    >
                      <h5 className="m-0">Types</h5>
                      <button
                        className="btn btn-light"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          padding: "8px 16px",
                          borderRadius: "8px",
                        }}
                        onClick={handleTypeModalShow}
                      >
                        <Add /> Add Type
                      </button>
                    </Box>
                    <Box sx={{ my: 4 }}>
                      {categoryById.types && categoryById.types.length > 0 ? (
                        <Box sx={customStyles.scrollableTableWrapper}>
                          <Paper sx={{ width: "100%", boxShadow: "none" }}>
                            <DataGrid
                              rows={categoryVehicleType}
                              columns={typesColumns}
                              initialState={{ pagination: { paginationModel } }}
                              pageSizeOptions={[5, 10]}
                              checkboxSelection
                              sx={{ border: 0 }}
                              slotProps={{
                                pagination: {
                                  sx: {
                                    justifyContent: "center",
                                    display: "flex",
                                    alignItems: "center",
                                  },
                                },
                              }}
                            />
                          </Paper>
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            ...customStyles.flexCenterXY,
                            width: "100%",
                            minHeight: "300px",
                          }}
                        >
                          <p>No Types Added Yet</p>
                        </Box>
                      )}
                    </Box>
                  </>
                </Box>
              </div>
            ) : (
              <div className="my-3 border rounded-3 min-vh-100">
                <div className="m-4">
                  <div className="d-flex justify-content-between align-items-center custom-card-sm my-3 ">
                    <h4 className="m-0">Properties</h4>
                    <button
                      onClick={handlePropertyShow}
                      className="btn btn-light rounded-3 custom-btn-size-responsive"
                    >
                      <Add />
                      Add Property
                    </button>
                  </div>
                  <div className="data-grid-small my-3">
                    <Paper sx={{ height: "auto", width: "100%" }}>
                      <DataGrid
                        autoHeight
                        rows={vehiclesProperties}
                        columns={PropertiesColumns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[5, 10]}
                        sx={{ border: 0 }}
                        checkboxSelection
                      />
                    </Paper>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* <div className="row min-vh-100">
          <div className="col-12 col-lg-4 col-xl-3">
                
             
          </div>
          <div className="col-lg-9 col-md-8 col-sm-12 p-0">
      

          </div>
        </div> */}
      </div>
    </>
  );
};

export default BrandVehicle;
